import { View, Text } from "react-native";
import { useState } from "react";
import { white } from "../../StyleHelpers";
import icon from "../../assets/TopNavBarIcon/icon_nav_proceed.png";
import Image from "../Image/Image";
import ITouchableButtonProps from "../../models/ITouchableButtonProps";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { StyledBottomInnerContainer, StyledBtnPaper, StyledTextContainer } from "./styled";

const LegalButton = ({ title, disabled, onPress, rightIcon, ...rest }: ITouchableButtonProps) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		//@ts-ignore
		<StyledBtnPaper
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			isHovered={!disabled && isHovered}
			mode="contained-tonal"
			onPress={onPress}
			labelStyle={{ width: "100%" }}
			contentStyle={{ height: "72px", width: "100%" }}
			type={ComponentTypeEnum.Secondary}
			disabled={disabled}
			{...rest}
		>
			{/* @ts-ignore */}
			<StyledBottomInnerContainer>
				<View>
					<StyledTextContainer>
						<Text style={{ opacity: disabled ? 0.5 : 1, color: white }}>{title}</Text>
					</StyledTextContainer>
				</View>
				<View>
					<Image style={{ opacity: disabled ? 0.5 : 1 }} source={{ uri: rightIcon || icon }} resizeMode="contain" width={24} height={24} />
				</View>
			</StyledBottomInnerContainer>
		</StyledBtnPaper>
	);
};

export default LegalButton;
